import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreService } from '../../../services/core.service';
import { Router } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StepperGridComponent } from '../stepper-grid/stepper-grid.component';
import { FooterGridComponent } from '../../manage-account/components/footer-grid/footer-grid.component';
import { LatestPostsSidebarComponent } from "../latest-posts-sidebar/latest-posts-sidebar.component";

@Component({
  selector: 'app-upload-results-step',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    StepperGridComponent,
    FooterGridComponent,
    LatestPostsSidebarComponent
],
  templateUrl: './social-ai-bulk-results.component.html',
  styleUrls: ['./social-ai-bulk-results.component.scss']
})
export class SocialAiBulkResultsComponent implements OnInit {
  companyID = 0;
  importId: number | null = null;
  today: Date = new Date();

  displayedColumns: string[] = [
    'file_name',
    'valid_posts',
    'post_details',
    'invalid_posts',
    'error_details',
    'created_at'
  ];

  dataSource = new MatTableDataSource<any>([]);
  expandedElement: any | null = null;
  expandedErrorLogsElement: any | null = null;

  weekDays: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];

  constructor(
    private readonly coreService: CoreService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.companyID = this.coreService.user?.companyID || 0;

    if (!this.companyID) {
      this.coreService.showSnackbar('No company found.');
      return;
    }

    this.loadData();
  }

  loadData(): void {
    const payload: any = { company_id: this.companyID };

    if (this.importId) {
      payload.import_id = this.importId;
    }

    this.coreService.postData('bulks/lastImport', payload).subscribe((res: any) => {
      const importLogs = res.import_log ? [res.import_log] : [];

      const data = importLogs.map((item: any) => ({
        ...item,
        failed_posts: item.failed_posts?.map((fp: any) => ({
          ...fp,
          error_messages: this.safeParse(fp.error_messages)
        })) || []
      }));

      this.dataSource.data = data;
    });
  }

  private safeParse(value: any) {
    try {
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch {
      return { message: value };
    }
  }

  editRow(row: any): void {
    this.router.navigate(['/manual-post/edit', row.id]);
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  gotToViewBulks(): void {
    this.router.navigate(['/bulk-posts']);
  }
}
